// extracted by mini-css-extract-plugin
export default {"scan":"L5BWEqPhidqS-oM2Rxq2bQ==","close":"VMeitnWZGta6IrlXS18t6Q=="};